import { t } from "@lingui/core/macro";

export const BOOKING_STATS_ENABLED = ["/travel", "/travel/hotels"];

export const PASSWORD_MIN_STR = 3;

export const SORT_BY_OPTIONS = [
  { label: `Distance`, key: "distance" },
  { label: `Relevance`, key: "relevance" },
  { label: `Popularity`, key: "uses" },
];

export function i18nMapSortOptions(label) {
  switch (label) {
    case `Distance`:
      return t`Distance`;
    case `Relevance`:
      return t`Relevance`;
    case `Popularity`:
      return t`Popularity`;
    case `Best Match`:
      return t`Best Match`;
    default:
      return label;
  }
}

export const SUGGEST_MENU_OPTION = "suggest-menu-option";

/*
 * VWO is used for A/B testing and personalization
 * The cookie names are as follows:
 * Navigation A/B Test = _vis_opt_exp_123_combi
 * Search & Location A/B Test = _vis_opt_exp_126_combi
 */

export const VWO_COOKIE = "_vis_opt_exp_126_combi";
export const VWO_COOKIE_VALUE_OPT_1 = "-100";
export const VWO_COOKIE_VALUE_OPT_2 = "2";

export const LANGUAGE_COOKIE = "adc_d_language";
export const IP_LOCATION_COOKIE = "adc_d_ipLocation";
export const DEFAULT_LOCATION_COOKIE = "adc_d_defaultLocation";
export const CURRENT_NAV_COOKIE = "adc_d_currentNav";
export const SETUP_LATER_COOKIE = "adc_d_smsZipSetupLater";

export const ONLINE_OPTIONS = {
  ONLY: "only",
  NONE: "none",
  INCLUDE: "include",
};

export const ONLINE_KEYS = {
  ONLY: `online_${ONLINE_OPTIONS.ONLY}`,
  NONE: `online_${ONLINE_OPTIONS.NONE}`,
  INCLUDE: `online_${ONLINE_OPTIONS.INCLUDE}`,
};

export const SORT_OPTIONS = {
  DISTANCE: "distance",
  RELEVANCE: "relevance",
  POPULARITY: "uses",
};

export const DEALS_SSO_LOCATION_TRACKING_KEY_NAME = "target_view";
export const DEALS_SSO_TOKEN_PARAMS = ["state", "code"];
// other related SSO token params are: "scope", "code_challenge_method"
// but not needed for auth request to MMS API

export const ATTRACTION_TYPES = {
  ATTRACTION: "ATTRACTION",
  DEALS: "DEALS",
  DEALS_TICKETS: "DEALS_TICKETS",
};
